import React from "react";
import "./contact.css";

export default function Contact() {
  return (
    <div className="page">
      <div className="row no-gutters row-layout">
        <div className="col-lg">
          <div className="map-panel2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13244.303456373143!2d151.0341269!3d-33.913447!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4cb8e8a429ff077c!2sBlack%20Jade%20Tattoo!5e0!3m2!1sen!2sau!4v1613820534818!5m2!1sen!2sau"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
      <div className="row no-gutters">
        <div className="column col-lg-6" style={{ backgroundColor: "#fff" }}>
          <div className="column-info column-location">
            <a href="https://goo.gl/maps/NV4XE7fn7zoiot568" target="_blank">
              <i className="fas fa-map-marked-alt lbc-icon"></i>
              <p>
                Little Saigon Plaza, Level 1 <br />
                Shop 13/462 Chapel Rd, Bankstown NSW 2200
              </p>
            </a>

            <i className="far fa-clock lbc-icon"></i>
            <p>Open Everyday: 10AM - 6PM</p>

            <a href="tel:0297962994">
              <i className="fas fa-mobile-alt lbc-icon"></i>
              <p>(02) 9796 2994</p>
            </a>

            <a href="mailto:blackjadetattoo@hotmail.com">
              <i className="far fa-envelope lbc-icon"></i>
              <p>blackjadetattoo@hotmail.com</p>
            </a>
          </div>
        </div>

        <div className="column col-lg-6">
          <div className="col-image contact-header"></div>
        </div>
      </div>
    </div>
  );
}
